import React from 'react'
import {
  EmptyStateContainer,
  HeaderContainer,
  IconWrapper,
  TextContainer,
  SectionHeader,
  SectionSubheader,
} from './FunderGoalsEmptyState.styled'

type GoalSectionEmptyStateProps = {
  icon: React.ReactNode
  headerText: string
  subheaderText: string
}

export const GoalSectionEmptyState = ({
  icon,
  headerText,
  subheaderText,
}: GoalSectionEmptyStateProps) => (
  <EmptyStateContainer>
    <HeaderContainer>
      <IconWrapper>{icon}</IconWrapper>
      <TextContainer>
        <SectionHeader variant='h6'>{headerText}</SectionHeader>
        <SectionSubheader variant='body2'>{subheaderText}</SectionSubheader>
      </TextContainer>
    </HeaderContainer>
  </EmptyStateContainer>
)
